<script setup lang="ts">
import { LOCALE } from "core/interfaces";

import { navigateToItemDetails } from "~/common/helpers/navigate-to-item-details";

const { locale } = useI18n();
const shopStore = useShopStore();

const navigateToItemDetailsBound = navigateToItemDetails.bind(this, locale.value as LOCALE, shopStore.components.kinds);
</script>

<template>
	<section>
		<p class="uppercase text-xl xs:text-lg">
			{{ $t('recentlyViewed') }} <b>{{ $t('product', 2) }}</b>
		</p>
		<div
			class="mt-7 mb-7 grid grid-cols-[repeat(auto-fill,minmax(256px,1fr))] gap-x-4 gap-y-6 overflow-x-scroll lg:gap-6 sm:mt-4 sm:mb-6 xs:mt-4 xs:mb-6 xs:grid-cols-2"
		>
			<ItemCard
				v-for="item in shopStore.recentlyViewedProducts"
				:key="item.id"
				:item="item"
				@click="navigateToItemDetailsBound(item)"
			/>
		</div>
	</section>
</template>
